import { render, staticRenderFns } from "./ProductContentTabs.vue?vue&type=template&id=750843f4&scoped=true"
import script from "./ProductContentTabs.vue?vue&type=script&lang=js"
export * from "./ProductContentTabs.vue?vue&type=script&lang=js"
import style0 from "./ProductContentTabs.vue?vue&type=style&index=0&id=750843f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750843f4",
  null
  
)

export default component.exports